import { Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';


@Injectable({
  providedIn: 'root'
})
export class ConfigTituloPaginasService {

  constructor(
    private tituloService: Title,
    private edicionSeccionesService: EdicionSeccionesService,
    private preferenciasService: PreferenciasService,
    private meta: Meta
  ) { }

  establecerTitulo(titulo, seccionEditable?, precarga?, titulotag?) {
    // let nombreComercial = this.preferenciasService.get('matrix_nombreComercial');
    if (seccionEditable && precarga && titulotag) {
      precarga?.elementos.forEach((elemento, index) => {
        let indice = (precarga.multiple) ? index : -1;
        let tituloEditable = this.edicionSeccionesService.getCamposEdicionItem(elemento, titulotag, indice);
        // this.tituloService.setTitle(tituloEditable + ' | ' + nombreComercial);
        this.tituloService.setTitle(tituloEditable);
        return;
      });
    } else {
      // this.tituloService.setTitle(titulo + ' | ' + nombreComercial);
      this.tituloService.setTitle(titulo);
    }
  }

  establecerMeta(contenido: string, seccionEditable?, precarga?, titulotag?): void {
    if (seccionEditable && precarga && titulotag) {
      precarga?.elementos.forEach((elemento, index) => {
        let indice = (precarga.multiple) ? index : -1;
        let metaDescriptionEditable = this.edicionSeccionesService.getCamposEdicionItem(elemento, titulotag, indice);
        this.updateMeta({ name: 'description', content: metaDescriptionEditable });
        return;
      });
    } else {
      this.updateMeta({ name: 'description', content: contenido });
    }
  }

  updateMeta(metaTag: MetaDefinition): void {
    this.meta.updateTag(metaTag);
  }
}
